import { render, staticRenderFns } from "./CustomerOrdersOrderLink.vue?vue&type=template&id=53b85218&"
import script from "./CustomerOrdersOrderLink.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersOrderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports